module.exports = __webpack_public_path__ + "static/media/2displays_2videos.211af4f3.png";